import type { Pixel } from '@/data'
import api from '..'

export async function getPixel(id: string): Promise<Pixel | null> {
  const res = await api.get(`/pixels/${id}`)
  return res.data.data
}
